export default __webpack_public_path__ + "static/media/chevronDown.8d9c69ff.svg";